import { render, staticRenderFns } from "./PackPreview.vue?vue&type=template&id=0456a320&"
import script from "./PackPreview.vue?vue&type=script&lang=ts&"
export * from "./PackPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports